import { sortPlayers, sortSpellAssignments } from 'web/utils/sort-utils'
import { secondsToTimestamp } from 'web/utils/time-utils'
import { expectOneById, groupList } from 'web/utils/utils'
import { getBuildByPatchInfo } from './core-data'
import { FightSetup, FullFight, SpellAssignment } from './models'

export function generateWaArNote(params: {
    setup: FightSetup
    fullFight: FullFight
}) {
    const { fullFight, setup } = params

    const build = getBuildByPatchInfo(setup.patchInfo)

    const assignmentsPerPlayer = groupList(setup.spellAssignments, (item) => item.playerId)
    const sortedPlayers = [...setup.fightPlayers].sort(sortPlayers)

    const noteLines: string[] = []

    sortedPlayers.forEach(player => {
        const playerAssignments = assignmentsPerPlayer.get(player.id)

        playerAssignments.sort((a, b) => sortSpellAssignments(
            build,
            setup.fightPlayers,
            a,
            b
        ))

        const sortedByTime = playerAssignments
            .reduce<{
                offsetSeconds: number
                assignment: SpellAssignment
            }[]>((acc, assignment) => {

                const offsetSeconds = expectOneById(
                    fullFight.events,
                    assignment.fightEventId
                ).offset

                acc.push({ offsetSeconds, assignment })
                return acc

            }, [])
            .sort((a, b) => a.offsetSeconds - b.offsetSeconds)


        noteLines.push(``)
        noteLines.push(`-- ${player.name} --`)

        sortedByTime.forEach(({ assignment, offsetSeconds }) => {
            const timestamp = secondsToTimestamp(offsetSeconds)
            const name = build.Spell(assignment.spellId).name

            noteLines.push(`${timestamp} ${name}`)
        })
    })

    noteLines.splice(0, 1)
    return noteLines.join("\n")
}
